import { Skeleton } from '@teamsnap/snap-ui';
import * as React from 'react';

export default function LoadingTableAndKeyInsights() {
  return (
    <>
      <div className="sui-bg-neutral-background-weak sui-rounded sui-p-4 sui-w-full sui-max-w-[420px]">
        <div className="sui-mb-4 sui-flex sui-gap-3">
          <div>
            <Skeleton className="sui-w-[50px] sui-h-[12px] sui-mb-2" />
            <Skeleton className="sui-w-[80px] sui-h-[30px]" />
          </div>
          <div>
            <Skeleton className="sui-w-[50px] sui-h-[12px] sui-mb-2" />
            <Skeleton className="sui-w-[80px] sui-h-[30px]" />
          </div>
          <div>
            <Skeleton className="sui-w-[50px] sui-h-[12px] sui-mb-2" />
            <Skeleton className="sui-w-[80px] sui-h-[30px]" />
          </div>
        </div>
        <div className="sui-flex sui-gap-1">
          <Skeleton />
          <Skeleton className="sui-w-[200px]" />
        </div>
      </div>
      <table className="sui-w-full sui-overflow-x-auto sui-mt-2">
        <thead>
          <tr className="sui-border-b-2 sui-border-solid sui-border-gray-90">
            <th className="sui-p-2">
              <Skeleton className="sui-w-[80px]" />
            </th>
            <th className="sui-p-2 sui-pr-[100px]">
              <Skeleton className="sui-w-[110px]" />
            </th>
            <th className="sui-p-2">
              <div className="sui-flex sui-gap-1">
                <Skeleton className="sui-w-[100px]" />
                <Skeleton />
              </div>
            </th>
            <th className="sui-p-2">
              <div className="sui-flex sui-gap-1">
                <Skeleton className="sui-w-[100px]" />
                <Skeleton />
              </div>
            </th>
            <th className="sui-p-2">
              <Skeleton className="sui-w-[50px]" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="sui-border-b sui-border-solid sui-border-gray-90">
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[60px]" />
            </td>
            <td className="sui-px-2 sui-py-3 sui-pr-[100px]">
              <Skeleton className="sui-w-[240px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[90px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[60px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[120px]" />
            </td>
          </tr>
          <tr className="sui-border-b sui-border-solid sui-border-gray-90">
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[60px]" />
            </td>
            <td className="sui-px-2 sui-py-3 sui-pr-[100px]">
              <Skeleton className="sui-w-[300px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[60px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[70px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[120px]" />
            </td>
          </tr>
          <tr className="sui-border-b sui-border-solid sui-border-gray-90">
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[70px]" />
            </td>
            <td className="sui-px-2 sui-py-3 sui-pr-[100px]">
              <Skeleton className="sui-w-[270px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[50px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[70px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[120px]" />
            </td>
          </tr>
          <tr className="sui-border-b sui-border-solid sui-border-gray-90">
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[60px]" />
            </td>
            <td className="sui-px-2 sui-py-3 sui-pr-[100px]">
              <Skeleton className="sui-w-[240px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[90px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[60px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[120px]" />
            </td>
          </tr>
          <tr className="sui-border-b sui-border-solid sui-border-gray-90">
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[60px]" />
            </td>
            <td className="sui-px-2 sui-py-3 sui-pr-[100px]">
              <Skeleton className="sui-w-[300px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[60px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[70px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[120px]" />
            </td>
          </tr>
          <tr className="sui-border-b sui-border-solid sui-border-gray-90">
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[70px]" />
            </td>
            <td className="sui-px-2 sui-py-3 sui-pr-[100px]">
              <Skeleton className="sui-w-[270px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[50px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[70px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[120px]" />
            </td>
          </tr>
          <tr className="sui-border-b sui-border-solid sui-border-gray-90">
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[60px]" />
            </td>
            <td className="sui-px-2 sui-py-3 sui-pr-[100px]">
              <Skeleton className="sui-w-[240px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[90px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[60px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[120px]" />
            </td>
          </tr>
          <tr className="sui-border-b sui-border-solid sui-border-gray-90">
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[60px]" />
            </td>
            <td className="sui-px-2 sui-py-3 sui-pr-[100px]">
              <Skeleton className="sui-w-[300px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[60px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[70px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[120px]" />
            </td>
          </tr>
          <tr className="sui-border-b sui-border-solid sui-border-gray-90">
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[70px]" />
            </td>
            <td className="sui-px-2 sui-py-3 sui-pr-[100px]">
              <Skeleton className="sui-w-[270px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[50px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[70px]" />
            </td>
            <td className="sui-px-2 sui-py-3">
              <Skeleton className="sui-w-[120px]" />
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
}
